import {MuRouter} from "mu-widget/lib/MuRouter";
import {AnyElement} from "mu-widget/lib/MuWidget";
import {Ticket} from "./TicketTypes";
import {Arrays} from "./Utils";

export class BaseRouter extends MuRouter {
    paTicket(a: AnyElement|AnyElement[], ticket: Ticket) {
        // this.prepareAnchor();
        Arrays.ooaToArray(a).forEach(el => (el as unknown as HTMLAnchorElement).href = '/ticket/detail/' + ticket.id);
    }

    paProcData(a: AnyElement|AnyElement[], procDataId: number) {
        // this.prepareAnchor();
        Arrays.ooaToArray(a).forEach(el => (el as unknown as HTMLAnchorElement).href = '/ticket/proc-data-detail?procDataId=' + procDataId);
    }
}